import type { Address } from '@/shared/types/address';

export function AddressCity({ data }: { data?: Address }) {
  if (!data?.city) {
    return null;
  }

  return <div>{data.city}</div>;
}
